<template>
    <div>
        <pc-select
            v-model="selectedIndex"
            v-bind:label="reorderTableSelectorLabel"
            v-bind:options="availableRows" />
    </div>
</template>

<script>
    import { KEYS, NAMESPACE } from "./i18n/reorderTableDialog.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            tableSize: { type: Number, required: true },
            startIndex: { type: Number, required: true },
            initialIndex: { type: Number, required: true }
        },
        data: function () {
            return {
                selectedIndex: 1
            };
        },
        computed: {
            availableRows() {
                const result = [];
                for (let i = this.startIndex; i <= this.tableSize; i++) {
                    result.push({ value: i, text: i });
                }
                return result;
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        watch: {
            intialIndex: function (newVal) {
                this.selectedIndex = newVal;
            }
        },
        mounted() {
            this.selectedIndex = this.initialIndex;
        },
        methods: {
            getNewRowNumber() {
                return this.selectedIndex;
            }
        }
    };
</script>
